// extracted by mini-css-extract-plugin
module.exports = {"base":"base--g6S7LJ","error":"error--Qtn8gf"};